import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section id=\"home\" class=\"h40 d-flex align-items-center bg-faq section-padding mt-5 mt-md-0\"><div class=\"container\"><div class=\"row justify-content-center text-center\"><div class=\"col-sm-12 col-lg-10\"><h1 class=\"title text-shadow\">Preguntas frecuentes</h1></div></div></div></section>", 1)
const _hoisted_2 = {
  id: "work",
  app: "app"
}
const _hoisted_3 = { class: "py-5 d-flex align-items-center" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "text-justify px-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " Somos la primer plataforma en Guatemala, dedicada a ayudar al público guatemalteco a llegar con el prestador de servicios y/o productos financiero adecuado para él. ", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" En Guatemala, existen más de 5,000 productos y servicios financieros, y es muy complicado saber en cuál de todos, cumples los requisitos para ser aprobado, por eso, en ")
const _hoisted_8 = { class: "text-orange-400" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" buscamos entre todos los servicios y productos disponibles (tarjetas de crédito, préstamos y sanadores de deudas), y encontramos el que es adecuado para cada perfil. ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " Como usuario, únicamente tendrás que contestar unas preguntas, y en menos de 60 segundos, nuestro sistema evaluará tu perfil, y te enviará con el producto que es perfecto para ti. ", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" El servicio es 100% gratuito, nunca deberás pagar anticipos, depósitos, ni cualquier otro cargo al usar ")
const _hoisted_12 = { class: "text-orange-400" }
const _hoisted_13 = { class: "text-center mt-5" }
const _hoisted_14 = { class: "text-justify px-3" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" En ")
const _hoisted_16 = { class: "text-orange-400" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(", somos socios de los bancos y los prestamistas, conocemos cuáles son las características que necesitan para aprobar sus tarjetas de crédito y sus préstamos, y todo esa información, está guardada en nuestro sistema. Cuando un usuario contesta uno de nuestros cuestionarios, nuestro sistema analiza sus respuestas, y le asigna a un banco o prestamista, que busca a personas con esas características, de esta manera, la probabilidad de aprobación, es sumamente alta. ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Estos son los pasos que deberás seguir para obtener un producto o servicio financiero a través de ")
const _hoisted_19 = { class: "text-orange-400" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_21 = { class: "list-none" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 1. Entra a ")
const _hoisted_23 = { class: "text-orange-400" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode(" 2. Elige una de las opciones disponibles: "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, " 2.1 Quiero mi oferta: Si eliges esta opción, nosotros buscaremos entre todos los productos y servicios financieros disponibles (tarjetas de crédito y préstamos). Y al finalizar tu cuestionario, te enviaremos con el servicio o producto perfecto para ti. "),
    /*#__PURE__*/_createElementVNode("li", null, " 2.2 Préstamos Personales: Si eliges esta opción, nosotros buscaremos entre todos los prestamistas disponibles, y te podremos enviar con el que te ofrece lo buscas, y en el que cumples los requisitos para ser aprobado. ")
  ])
], -1)
const _hoisted_25 = { class: "text-center mt-5" }
const _hoisted_26 = { class: "text-justify px-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Nuestro servicio no tiene ningún costo, es completamente gratuito. También la asesoría financiera es gratuita, y puedes solicitarla escribiéndonos cualquier duda a "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:info@leadgenios.com",
    target: "_blank"
  }, "info@leadgenios.com"),
  /*#__PURE__*/_createTextVNode(", nuestro equipo de trabajo te responderá en un plazo no mayor a las 72 horas. ")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, " Recuerda que nuestro servicio está disponible las 24 horas, los 365 días del año. ", -1)
const _hoisted_29 = { class: "text-center mt-5" }
const _hoisted_30 = { class: "text-justify px-3" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" El proceso para llegar al producto o servicio financiero adecuado para ti, es muy rápido en ")
const _hoisted_32 = { class: "text-orange-400" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(". Llenar nuestro cuestionario, no te llevará más de 10 minutos. ")
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" El tiempo para obtener el producto o servicio financiero, puede variar: "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("El más rápido, es instantáneo: al finalizar la solicitud en el sitio de nuestro socio, obtendrás el servicio. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("El más lento, puede llevar hasta 5 días hábiles: al terminar la solicitud en el sitio de nuestro socio, seguirá un proceso para continuar. ")
], -1)
const _hoisted_35 = { class: "text-center mt-5" }
const _hoisted_36 = { class: "text-justify px-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" ¡Sí! Desde cualquier lugar dentro de Guatemala, puedes usar nuestro servicio. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("¡Se acabaron las solicitudes rechazadas! ")
], -1)
const _hoisted_38 = { class: "text-center mt-5" }
const _hoisted_39 = { class: "text-justify px-3" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", null, " Por que somos la única plataforma en Guatemala, que te lleva directamente al producto o servicio perfecto para ti. Te evitamos la molestia de llenar muchas solicitudes en distintos sitios. Aquí llenas una sola, y obtienes lo que buscas. ", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", null, "¡Se acabaron las solicitudes rechazadas!", -1)
const _hoisted_42 = { class: "text-center mt-5" }
const _hoisted_43 = { class: "text-justify px-3" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", null, " Sí tenemos oficinas, sin embargo el servicio es totalmente en línea. En nuestras oficinas, únicamente trabajamos todos los días, para mejorar el proceso en línea. ", -1)
const _hoisted_45 = { class: "text-center mt-5" }
const _hoisted_46 = { class: "text-justify px-3" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", null, " Toda la información que proporciones dentro de nuestro sitio web, así como a nuestros agentes, está protegida por la Ley Federal de Protección de Datos en Posesión de Particulares. No debes de preocuparte. ", -1)
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" Además, en ")
const _hoisted_49 = { class: "text-orange-400" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" únicamente trabajamos con empresas serias y reguladas, así que no debes tener miedo al utilizar nuestro servicio. ")
const _hoisted_51 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Si tienes más preguntas, por favor escríbenos a "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:info@leadgenios.com",
    target: "_blank"
  }, "info@leadgenios.com"),
  /*#__PURE__*/_createTextVNode(", y uno de nuestros agentes se pondrá en contacto contigo en menos de 24 horas. ")
], -1)
const _hoisted_52 = { class: "text-center mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Accordion, { activeIndex: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_AccordionTab, {
                header: `¿Qué es ${_ctx.name}?`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("p", null, [
                      _hoisted_7,
                      _createElementVNode("strong", _hoisted_8, _toDisplayString(_ctx.name), 1),
                      _hoisted_9
                    ]),
                    _hoisted_10,
                    _createElementVNode("p", null, [
                      _hoisted_11,
                      _createElementVNode("strong", _hoisted_12, _toDisplayString(_ctx.name), 1)
                    ]),
                    _createElementVNode("p", _hoisted_13, [
                      _createVNode(_component_router_link, { to: '/cuestionario' }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Button, {
                            label: "Solicitar ahora",
                            class: "p-button-raised p-button-rounded w-auto"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_AccordionTab, {
                header: `¿${_ctx.name} es un prestamista?`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("p", null, [
                      _hoisted_15,
                      _createElementVNode("strong", _hoisted_16, _toDisplayString(_ctx.name), 1),
                      _hoisted_17
                    ]),
                    _createElementVNode("p", null, [
                      _hoisted_18,
                      _createElementVNode("strong", _hoisted_19, _toDisplayString(_ctx.name), 1),
                      _hoisted_20
                    ]),
                    _createElementVNode("ul", _hoisted_21, [
                      _createElementVNode("li", null, [
                        _hoisted_22,
                        _createElementVNode("strong", _hoisted_23, _toDisplayString(_ctx.name), 1)
                      ]),
                      _hoisted_24
                    ]),
                    _createElementVNode("p", _hoisted_25, [
                      _createVNode(_component_router_link, { to: '/cuestionario' }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Button, {
                            label: "Solicitar ahora",
                            class: "p-button-raised p-button-rounded w-auto"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_AccordionTab, {
                header: '¿Cuánto cuesta el servicio de ' + _ctx.name + '?'
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _hoisted_28,
                    _createElementVNode("p", _hoisted_29, [
                      _createVNode(_component_router_link, { to: '/cuestionario' }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Button, {
                            label: "Solicitar ahora",
                            class: "p-button-raised p-button-rounded w-auto"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_AccordionTab, { header: "¿Cuánto tarda el proceso?" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("p", null, [
                      _hoisted_31,
                      _createElementVNode("strong", _hoisted_32, _toDisplayString(_ctx.name), 1),
                      _hoisted_33
                    ]),
                    _hoisted_34,
                    _createElementVNode("p", _hoisted_35, [
                      _createVNode(_component_router_link, { to: '/cuestionario' }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Button, {
                            label: "Solicitar ahora",
                            class: "p-button-raised p-button-rounded w-auto"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_AccordionTab, {
                header: '¿' + _ctx.name + ' está disponible en todo Guatemala?'
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("p", _hoisted_38, [
                      _createVNode(_component_router_link, { to: '/cuestionario' }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Button, {
                            label: "Solicitar ahora",
                            class: "p-button-raised p-button-rounded w-auto"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_AccordionTab, {
                header: '¿Por qué usar ' + _ctx.name + '?'
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _hoisted_41,
                    _createElementVNode("p", _hoisted_42, [
                      _createVNode(_component_router_link, { to: '/cuestionario' }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Button, {
                            label: "Solicitar ahora",
                            class: "p-button-raised p-button-rounded w-auto"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_AccordionTab, {
                header: '¿' + _ctx.name + ' tiene oficinas?'
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("p", _hoisted_45, [
                      _createVNode(_component_router_link, { to: '/cuestionario' }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Button, {
                            label: "Solicitar ahora",
                            class: "p-button-raised p-button-rounded w-auto"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_AccordionTab, { header: "¿Mi información está segura?" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("p", null, [
                      _hoisted_48,
                      _createElementVNode("strong", _hoisted_49, _toDisplayString(_ctx.name), 1),
                      _hoisted_50
                    ]),
                    _hoisted_51,
                    _createElementVNode("p", _hoisted_52, [
                      _createVNode(_component_router_link, { to: '/cuestionario' }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Button, {
                            label: "Solicitar ahora",
                            class: "p-button-raised p-button-rounded w-auto"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}